<div id="table-to-cards-container">
    <div class="select-all-checkbox" *ngIf="showSelectionView && pageData && pageData.length">
        <mat-checkbox
            (change)="onToggleAllRowsChangeEvent($event)"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
        >
            {{ 'selectAll' | translate }}
        </mat-checkbox>
    </div>
    <div class="table-row-card" *ngFor="let row of pageData" (click)="onCardClick(row, viewType)">
        <div class="table-row-card__header">
            <div class="item-info d-flex justify-content-space-between">
                <div class="d-flex">
                    <div class="item-checkbox-selection ms-2" *ngIf="showSelectionView">
                        <mat-checkbox
                            (click)="$event.stopPropagation()"
                            (change)="onRowChangeEvent($event, row)"
                            [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)"
                        >
                        </mat-checkbox>
                    </div>
                    <div class="item-id fw-bold" *ngIf="row.number || row.id">#{{ row.number || row.id }}</div>
                </div>
                <div>
                    <span *ngIf="displayedColumns.includes('status') && viewType !== viewTypes.CALL_RECORD" class="divStatus">
                        <span class="statuSub status-{{ row.status }}" *ngIf="row.status">
                            {{ row.status | translate }}
                        </span>
                    </span>
                </div>
                <div
                    class="item-status d-flex align-items-center"
                    *ngIf="getRowStatus(row) || displayedColumns.includes('statusTxt') || displayedColumns.includes('sla')"
                >
                    <span *ngIf="getRowStatus(row)" class="status-details" [ngClass]="{ dashboard: viewType === viewTypes.DASHBOARD }">
                        <div class="in-progress" *ngIf="viewType === viewTypes.INPROGRESS_REQUESTS">
                            <span> {{ 'inprogress' | translate }} </span>
                        </div>
                        <div class="completed" *ngIf="viewType === viewTypes.COMPLETED_REQUESTS">
                            <span> {{ 'completed' | translate }} </span>
                        </div>
                        <div *ngIf="viewType === viewTypes.DASHBOARD" class="status" [ngClass]="getRowStatus(row)">
                            <span> {{ getRowStatus(row) | translate }} </span>
                        </div>
                        <div *ngIf="viewType === viewTypes.EMPLOYEE_MANAGEMENT_REQUESTS" class="status" [ngClass]="getRowStatus(row)">
                            <ng-container *ngTemplateOutlet="accountManagerRequestsStatusTpl; context: { $implicit: row }"></ng-container>
                        </div>
                    </span>

                    <span
                        *ngIf="displayedColumns.includes('statusTxt')"
                        class="status-details me-2"
                        [ngClass]="{ dashboard: viewType === viewTypes.DASHBOARD }"
                    >
                        <div *ngIf="viewType === viewTypes.SECURITY_COORDINATOR_REQUESTS" class="status" [ngClass]="row.status">
                            <ng-container *ngTemplateOutlet="accountManagerRequestsStatusTpl; context: { $implicit: row }"></ng-container>
                        </div>
                        <div *ngIf="viewType === viewTypes.TECHNICAL_OPERATIONS_REQUESTS" class="status" [ngClass]="row.status">
                            <ng-container *ngTemplateOutlet="operationsRequestsStatusTpl; context: { $implicit: row }"></ng-container>
                        </div>
                    </span>
                    <span *ngIf="displayedColumns.includes('sla')" class="sla-wrapper" [ngClass]="row | requestServiceLevelAgreement: viewType"> </span>
                </div>
            </div>
        </div>
        <div class="table-row-card__body d-flex flex-column">
            <table class="table-items">
                <tbody>
                    <tr *ngFor="let column of displayedColumns; let i = index">
                        <td
                            *ngIf="
                                ![
                                    'eServiceNumber',
                                    'dateAndTime',
                                    'select',
                                    'closedDate',
                                    'operationclosedDate',
                                    'button',
                                    'status',
                                    'requestNumber',
                                    'sla',
                                    'statusTxt',
                                    'reportName',
                                    'auditor',
                                    'reportCode',
                                    'auditType',
                                    'owner',
                                    'department',
                                    'reportRequestDate',
                                    'returnedDate',
                                    'serialNumber',
                                    'deviceName',
                                    'userDeviceChanged',
                                    'source',
                                    'filedName',
                                    'number',
                                    'employee',
                                    'phoneNumber',
                                    'client',
                                    'requester'
                                ].includes(column) &&
                                viewType !== viewTypes.REPORT &&
                                viewType !== viewTypes.SHARED_REPORTS &&
                                viewType !== viewTypes.CALL_RECORD &&
                                viewType !== viewTypes.CALL_CENTER_CLIENT_REQUEST &&
                                viewType !== viewTypes.E_SERVICE_HISTORY_FEILD
                            "
                            class="fw-bold"
                        >
                            {{ column | translate }}
                        </td>
                        <td
                            *ngIf="
                                ![
                                    'eServiceNumber',
                                    'dateAndTime',
                                    'select',
                                    'closedDate',
                                    'operationclosedDate',
                                    'button',
                                    'status',
                                    'requestNumber',
                                    'sla',
                                    'statusTxt',
                                    'assignee',
                                    'completedByTo',
                                    'reportName',
                                    'auditor',
                                    'reportCode',
                                    'auditType',
                                    'owner',
                                    'department',
                                    'reportRequestDate',
                                    'returnedDate',
                                    'serialNumber',
                                    'deviceName',
                                    'userDeviceChanged',
                                    'source',
                                    'filedName',
                                    'number',
                                    'employee',
                                    'phoneNumber',
                                    'client',
                                    'requester'
                                ].includes(column) &&
                                viewType !== viewTypes.REPORT &&
                                viewType !== viewTypes.SHARED_REPORTS &&
                                viewType !== viewTypes.CALL_RECORD &&
                                viewType !== viewTypes.CALL_CENTER_CLIENT_REQUEST &&
                                viewType !== viewTypes.E_SERVICE_HISTORY_FEILD
                            "
                        >
                            {{ row[column] }}
                        </td>

                        <td *ngIf="column === 'assignee' || column === 'completedByTo'">
                            <span class="assignee-details">
                                <div *ngIf="row.assignee">
                                    <img class="assignee-image-wrapper" src="{{ row.assignee.image }}" onerror="this.src='assets/images/user2.jpg'" alt="" />
                                    <span> {{ row.assignee.name | tableDataFormat: column.columnDef }} </span>
                                </div>
                                <span *ngIf="!row.assignee" #noAssigneeDetails class="no-assignee-details"> </span>
                            </span>
                        </td>
                        <td
                            class="fw-bold"
                            *ngIf="
                                (column === 'closedDate' || column === 'dateAndTime' || column === 'operationclosedDate') &&
                                viewType !== viewTypes.REPORT &&
                                viewType !== viewTypes.SHARED_REPORTS &&
                                viewType !== viewTypes.CALL_RECORD &&
                                viewType !== viewTypes.CALL_CENTER_CLIENT_REQUEST &&
                                viewType !== viewTypes.E_SERVICE_HISTORY_FEILD
                            "
                        >
                            {{ column | translate }}
                        </td>

                        <td
                            class="direction"
                            *ngIf="
                                column === 'dateAndTime' &&
                                viewType !== viewTypes.REPORT &&
                                viewType !== viewTypes.SHARED_REPORTS &&
                                viewType !== viewTypes.CALL_RECORD &&
                                viewType !== viewTypes.CALL_CENTER_CLIENT_REQUEST &&
                                viewType !== viewTypes.E_SERVICE_HISTORY_FEILD
                            "
                            [ngClass]="{ 'text-start': translateService.currentLang === 'en', 'text-end': translateService.currentLang !== 'en' }"
                        >
                            {{ row.date | dateFormat: 'd MMM YYYY - h:mm a' | async }}
                        </td>
                        <td
                            class="direction"
                            *ngIf="
                                (column === 'closedDate' || column === 'operationclosedDate') &&
                                viewType !== viewTypes.REPORT &&
                                viewType !== viewTypes.SHARED_REPORTS
                            "
                            [ngClass]="{ 'text-start': translateService.currentLang === 'en', 'text-end': translateService.currentLang !== 'en' }"
                        >
                            {{ row.closedDate | dateFormat: 'd MMM YYYY - h:mm a' | async }}
                        </td>
                        <td
                            *ngIf="
                                column === 'status' &&
                                (viewType === inprogressRequestView || viewType === completedRequestView || viewType === employeeManagementRequestView)
                            "
                            class="fw-bold"
                        >
                            {{ column | translate }}
                        </td>
                        <td
                            *ngIf="
                                column === 'status' &&
                                (viewType === inprogressRequestView || viewType === completedRequestView || viewType === employeeManagementRequestView)
                            "
                        >
                            <span class="status-details" [ngClass]="{ dashboard: viewType === dashboardRequestView }">
                                <div class="in-progress" *ngIf="viewType === inprogressRequestView">
                                    <span> {{ 'inprogress' | translate }} </span>
                                </div>
                                <div class="completed" *ngIf="viewType === completedRequestView">
                                    <span> {{ 'completed' | translate }} </span>
                                </div>
                                <div *ngIf="viewType === dashboardRequestView" class="status" [ngClass]="row?.status">
                                    <span> {{ row?.status | translate }} </span>
                                </div>
                                <div *ngIf="viewType === employeeManagementRequestView" class="status" [ngClass]="row?.status">
                                    <ng-container *ngTemplateOutlet="accountManagerRequestsStatusTpl"></ng-container>
                                </div>
                            </span>
                        </td>
                    </tr>

                    <tr *ngFor="let columnData of columns; let i = index">
                        <td
                            *ngIf="
                                ['employee', 'phoneNumber', 'client', 'requester', 'service', 'dateAndTime', 'status'].includes(columnData.columnDef) &&
                                viewType === viewTypes.CALL_RECORD
                            "
                            class="fw-bold"
                        >
                            {{ columnData.columnDef | translate }}
                        </td>
                        <td
                            *ngIf="
                                ['employee', 'phoneNumber', 'client', 'requester', 'service', 'dateAndTime', 'status'].includes(columnData.columnDef) &&
                                viewType === viewTypes.CALL_RECORD
                            "
                        >
                            <span *ngIf="columnData.columnDef !== 'dateAndTime' && columnData.columnDef !== 'status'">
                                {{ columnData.cell(row) | tableDataFormat: columnData.columnDef }}
                            </span>

                            <span
                                class="date-column-table direction"
                                *ngIf="columnData.columnDef === 'dateAndTime' && viewType === viewTypes.CALL_RECORD"
                                [ngClass]="{ 'text-start': translateService.currentLang === 'en', 'text-end': translateService.currentLang !== 'en' }"
                            >
                                {{ columnData.cell(row) | dateFormat: 'd MMM YYYY - HH:mm ' | async }}
                            </span>

                            <span *ngIf="columnData.columnDef === 'status'" class="divStatus">
                                <span class="reportStatus {{ row.reportStatusCode }}">
                                    {{ columnData.cell(row) | tableDataFormat: columnData.cell(row) }}
                                </span>
                            </span>
                        </td>
                        <td
                            *ngIf="
                                ['filedName', 'oldValue', 'newValue', 'user', 'dateAndTime', 'feildType', 'feildAction'].includes(columnData.columnDef) &&
                                viewType === viewTypes.E_SERVICE_HISTORY_FEILD
                            "
                            class="fw-bold"
                        >
                            {{ columnData.columnDef | translate }}
                        </td>

                        <td
                            *ngIf="
                                ['filedName', 'oldValue', 'newValue', 'user', 'dateAndTime', 'feildType', 'feildAction'].includes(columnData.columnDef) &&
                                viewType === viewTypes.E_SERVICE_HISTORY_FEILD
                            "
                        >
                            <span *ngIf="columnData.columnDef !== 'dateAndTime'">
                                {{ columnData.cell(row) | tableDataFormat: columnData.columnDef }}
                            </span>

                            <span
                                class="date-column-table direction"
                                *ngIf="columnData.columnDef === 'dateAndTime' && viewType === viewTypes.E_SERVICE_HISTORY_FEILD"
                                [ngClass]="{ 'text-start': translateService.currentLang === 'en', 'text-end': translateService.currentLang !== 'en' }"
                            >
                                {{ columnData.cell(row) | dateFormat: 'd MMM YYYY - HH:mm ' | async }}
                            </span>
                        </td>
                        <td
                            *ngIf="
                                [
                                    'auditor',
                                    'reportCode',
                                    'status',
                                    'auditType',
                                    'closedDate',
                                    'owner',
                                    'department',
                                    'reportRequestDate',
                                    'returnedDate',
                                    'serialNumber',
                                    'deviceName',
                                    'userDeviceChanged',
                                    'source',
                                    'filedName'
                                ].includes(columnData.columnDef) &&
                                (viewType === viewTypes.REPORT || viewType === viewTypes.SHARED_REPORTS)
                            "
                            class="fw-bold"
                        >
                            {{ columnData.columnDef | translate }}
                        </td>

                        <td
                            *ngIf="
                                ['requester', 'sender', 'client', 'service', 'status', 'statusTxt', 'dateAndTime'].includes(columnData.columnDef) &&
                                viewType === viewTypes.CALL_CENTER_CLIENT_REQUEST
                            "
                            class="fw-bold"
                        >
                            {{ columnData.columnDef === 'requester' ? ('createdBy' | translate) : (columnData.columnDef | translate) }}
                        </td>

                        <td
                            *ngIf="
                                ['requester', 'sender', 'client', 'service', 'status', 'statusTxt', 'dateAndTime'].includes(columnData.columnDef) &&
                                viewType === viewTypes.CALL_CENTER_CLIENT_REQUEST
                            "
                        >
                            <span *ngIf="columnData.columnDef !== 'dateAndTime' && columnData.columnDef !== 'statusTxt'">
                                {{ columnData.cell(row) | tableDataFormat: columnData.columnDef }}
                            </span>

                            <span
                                class="date-column-table direction"
                                *ngIf="columnData.columnDef === 'dateAndTime'"
                                [ngClass]="{ 'text-start': translateService.currentLang === 'en', 'text-end': translateService.currentLang !== 'en' }"
                            >
                                {{ columnData.cell(row) | dateFormat: 'd MMM YYYY - h:mm a' | async }}
                            </span>
                            <span *ngIf="['statusTxt'].includes(columnData.columnDef)" class="status-details">
                                <div class="status" [ngClass]="columnData.cell(row)">
                                    <ng-container *ngTemplateOutlet="accountManagerRequestsCallCenterStatusTpl"></ng-container>
                                </div>
                            </span>
                            <ng-template #accountManagerRequestsCallCenterStatusTpl>
                                <ng-container *ngIf="columnData.cell(row) | getAdmissionStatus as Status">
                                    <span class="status-badge" [ngStyle]="{ color: Status.color, background: Status.bg }"> {{ Status.txt }} </span>
                                </ng-container>
                            </ng-template>
                        </td>
                        <td
                            *ngIf="columnData.columnDef === 'dateAndTime' && (viewType === viewTypes.REPORT || viewType === viewTypes.SHARED_REPORTS)"
                            class="fw-bold"
                        >
                            {{ 'creationDate' | translate }}
                        </td>
                        <td
                            *ngIf="
                                ([
                                    'auditor',
                                    'reportCode',
                                    'status',
                                    'auditType',
                                    'dateAndTime',
                                    'closedDate',
                                    'owner',
                                    'department',
                                    'reportRequestDate',
                                    'returnedDate',
                                    'serialNumber',
                                    'deviceName',
                                    'userDeviceChanged',
                                    'source',
                                    'filedName'
                                ].includes(columnData.columnDef) &&
                                    viewType === viewTypes.REPORT) ||
                                viewType === viewTypes.SHARED_REPORTS
                            "
                        >
                            <span
                                *ngIf="
                                    columnData.columnDef !== 'dateAndTime' &&
                                    columnData.columnDef !== 'status' &&
                                    columnData.columnDef !== 'closedDate' &&
                                    columnData.columnDef !== 'returnedDate' &&
                                    columnData.columnDef !== 'reportRequestDate' &&
                                    columnData.columnDef !== 'owner' &&
                                    columnData.columnDef !== 'userDeviceChanged'
                                "
                            >
                                {{ columnData.cell(row) | tableDataFormat: columnData.columnDef }}
                            </span>
                            <span *ngIf="columnData.columnDef === 'owner'">
                                <img src="{{ row.ownerImage }}" onerror="this.src='assets/images/user2.jpg'" class="imgStyle" alt="User image" />

                                {{ row.ownerName | tableDataFormat: columnData.columnDef }}
                            </span>

                            <div *ngIf="columnData.columnDef === 'userDeviceChanged'" class="d-flex">
                                <img src="{{ row.userImage }}" onerror="this.src='assets/images/user2.jpg'" class="imgStyle" alt="User image" />

                                <div class="d-flex div-name-email">
                                    <span>{{ row.userName | tableDataFormat: columnData.columnDef }}</span>
                                    <span>{{ row.userEmail | tableDataFormat: columnData.columnDef }}</span>
                                </div>
                            </div>
                            <span
                                class="date-column-table direction"
                                *ngIf="
                                    columnData.columnDef === 'dateAndTime' ||
                                    columnData.columnDef === 'closedDate' ||
                                    columnData.columnDef === 'reportRequestDate' ||
                                    columnData.columnDef === 'returnedDate'
                                "
                                [ngClass]="{ 'text-start': translateService.currentLang === 'en', 'text-end': translateService.currentLang !== 'en' }"
                            >
                                {{ columnData.cell(row) | dateFormat: 'd MMM YYYY - h:mm a' | async }}
                            </span>

                            <span *ngIf="columnData.columnDef === 'status'" class="divStatus">
                                <span class="reportStatus {{ row.reportStatusCode }}">
                                    {{ columnData.cell(row) | tableDataFormat: columnData.cell(row) }}
                                </span>
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td
                            class="fw-bold"
                            *ngIf="!displayedColumns.includes('dateAndTime') && viewType !== viewTypes.REPORT && viewType !== viewTypes.SHARED_REPORTS"
                        >
                            {{ 'date' | translate }}
                        </td>
                        <td *ngIf="!displayedColumns.includes('dateAndTime') && viewType !== viewTypes.REPORT && viewType !== viewTypes.SHARED_REPORTS">
                            {{ row['date'] | dateFormat: 'd MMM YYYY - h:mm a' | async }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="icons">
                                <span *ngIf="displayedColumns.includes('button') && row.status !== 'draft' && viewType !== viewTypes.CALL_RECORD"
                                    ><i class="fa fa-history" (click)="onHistoryRowClick(row, $event)"></i
                                ></span>
                                <span *ngIf="displayedColumns.includes('button') && viewType !== viewTypes.CALL_RECORD"
                                    ><i class="fa fa-eye" (click)="onRowClick(row)"></i
                                ></span>
                                <span *ngIf="displayedColumns.includes('button') && row.status === 'draft' && viewType !== viewTypes.CALL_RECORD"
                                    ><i class="fa fa-trash-o" (click)="onDeleteItem(row)"></i
                                ></span>
                                <span *ngIf="displayedColumns.includes('button') && row.containingSms === true && viewType === viewTypes.CALL_RECORD" class="notification-icon-container">
                                    <!-- Failed SMS -->
                                    <img 
                                        *ngIf="row.notificationStatus === 'FAILED'" 
                                        src="assets/images/failedSMS.svg" 
                                        alt="failed sms icon" 
                                        class="notification-icon failed-sms-icon clickable-icon" 
                                        (click)="onSmsClick(row, $event)"
                                        [title]="'failedToSend' | translate"
                                    />
                                    <!-- Success SMS -->
                                    <img 
                                        *ngIf="row.notificationStatus === 'SUCCESSFUL'" 
                                        src="assets/images/successSMS.svg" 
                                        alt="success sms icon" 
                                        class="notification-icon success-sms-icon clickable-icon" 
                                        (click)="onSmsClick(row, $event)"
                                        [title]="'sentSuccessfully' | translate"
                                    />
                                </span>

                                <span *ngIf="displayedColumns.includes('buttonReport') && reportType === 'AUDIT'">
                                    <img
                                        *ngIf="row.reportStatusCode !== auditReportStatuses.closed && row.reportStatusCode !== auditReportStatuses.cancelled"
                                        src="assets/images/notadd_comment.svg"
                                        alt="comments icon"
                                        (click)="onCommentItem(row, $event, true)"
                                    />
                                    <img
                                        *ngIf="row.reportStatusCode === auditReportStatuses.closed || row.reportStatusCode === auditReportStatuses.cancelled"
                                        alt="comments icon"
                                        src="assets/images/comments.svg"
                                        (click)="onCommentItem(row, $event, false)"
                                    />
                                </span>
                                <span *ngIf="displayedColumns.includes('buttonReport') && reportTabId === 1 && reportType === 'DEVICES'">
                                    <img
                                        *ngIf="row.reportStatusCode === auditReportStatuses.closed"
                                        src="assets/images/comments.svg"
                                        alt="comments icon"
                                        (click)="onCommentDeviceReportIconClick(row)"
                                    />
                                </span>
                                <span *ngIf="displayedColumns.includes('buttonReport') && reportType === 'AUDIT' && viewType === report">
                                    <img
                                        *ngIf="row.reportStatusCode === auditReportStatuses.closed || row.reportStatusCode === auditReportStatuses.cancelled"
                                        src="assets/images/export.svg"
                                        alt="comments icon"
                                        (click)="toggleTooltip(row.id, $event)"
                                    />
                                    <!-- Tooltip for Excel and PDF export -->
                                    <div
                                        class="tooltip"
                                        *ngIf="activeTooltipRowId === row.id"
                                        [ngClass]="{
                                            'rtl-tooltip': translateService.currentLang === 'ar',
                                            'ltr-tooltip': translateService.currentLang !== 'ar'
                                        }"
                                    >
                                        <div class="export-options">
                                            <img (click)="downloadWordFile(row, $event)" src="assets/images/exportWord.svg" alt="Word icon" class="icon" />
                                            <span class="text">{{ 'or' | translate }}</span>
                                            <img (click)="downloadExcelFile(row, $event)" src="assets/images/exportExcel.svg" alt="Excel icon" class="icon" />
                                            <span class="text">or</span>
                                            <img (click)="downloadPDF(row, $event)" src="assets/images/exportPdf.svg" alt="PDF icon" class="icon" />
                                        </div>
                                        <div class="tooltip-arrow"></div>
                                    </div>
                                    <img
                                        *ngIf="row.reportStatusCode !== auditReportStatuses.closed && row.reportStatusCode !== auditReportStatuses.cancelled"
                                        src="assets/images/export-disabled.svg"
                                        alt="comments icon"
                                    />
                                </span>

                                <span *ngIf="displayedColumns.includes('buttonReport') && reportType === 'DEVICES' && viewType === report">
                                    <img
                                        *ngIf="row.reportStatusCode === auditReportStatuses.closed || row.reportStatusCode === auditReportStatuses.inProgress"
                                        src="assets/images/export.svg"
                                        alt="comments icon"
                                        (click)="toggleTooltip(row.id, $event)"
                                    />
                                    <!-- Tooltip for Excel and PDF export -->
                                    <div
                                        class="tooltip"
                                        *ngIf="activeTooltipRowId === row.id"
                                        [ngClass]="{
                                            'rtl-tooltip': translateService.currentLang === 'ar',
                                            'ltr-tooltip': translateService.currentLang !== 'ar'
                                        }"
                                    >
                                        <div class="export-options">
                                            <img (click)="downloadExcelDevice(row, $event)" src="assets/images/exportExcel.svg" alt="Excel icon" class="icon" />
                                            <span class="text">or</span>
                                            <img (click)="downloadPDFDevice(row, $event)" src="assets/images/exportPdf.svg" alt="PDF icon" class="icon" />
                                        </div>
                                        <div class="tooltip-arrow"></div>
                                    </div>
                                    <img
                                        *ngIf="row.reportStatusCode !== auditReportStatuses.closed && row.reportStatusCode !== auditReportStatuses.inProgress"
                                        src="assets/images/export-disabled.svg"
                                        alt="comments icon"
                                    />
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="pagination-container" *ngIf="!showEmptyState && !showErrorState" [ngClass]="{ dashboard: viewType === viewTypes.DASHBOARD }">
        <ngb-pagination
            class="d-flex justify-content-center"
            [(page)]="page"
            [collectionSize]="collectionSize"
            [pageSize]="pageSize"
            [rotate]="true"
            [size]="paginationSize"
            [maxSize]="5"
            [boundaryLinks]="false"
            (pageChange)="onPageChange($event)"
        >
        </ngb-pagination>
    </div>
    <div class="empty-state-container text-center" *ngIf="showEmptyState">
        <div class="empty-state-container">
            <img src="assets/images/empty-state.png" />
            <p class="message">
                {{ viewType | requestListEmptyStateMessage | translate }}
            </p>
            <button *ngIf="refreshData" mat-button class="btn btn-coral refresh-btn" (click)="onRefreshBtnClick()">
                <span class="material-symbols-outlined"> autorenew </span>
                {{ 'refresh' | translate }}
            </button>
        </div>
    </div>
    <div class="error-state-container text-center" *ngIf="showErrorState">
        <div class="error-state-container" (click)="onRetryBtnClick()">
            <div class="icon-wrapper">
                <span class="material-symbols-outlined refresh-icon"> autorenew </span>
            </div>
            <p>{{ 'errorOccurredRefreshPageErrorMsg' | translate }}</p>
        </div>
    </div>
</div>
<app-loader [fullLoader]="false" *ngIf="isLoading"></app-loader>

<ng-template #accountManagerRequestsStatusTpl let-row>
    <ng-container *ngIf="row?.status || row?.statustxt | getAdmissionStatus as Status">
        <span class="status-badge" [ngStyle]="{ color: Status.color, background: Status.bg }"> {{ Status.txt }} </span>
    </ng-container>
</ng-template>

<ng-template #operationsRequestsStatusTpl let-row>
    <ng-container *ngIf="row.status || row.statustxt | getOperationStatus as Status">
        <span class="status-badge" [ngStyle]="{ color: Status.color, background: Status.bg }"> {{ Status.txt }} </span>
    </ng-container>
</ng-template>
